// Module
var code = "You should return to the clock, can you remember what it was like when you first went there? ";
// Exports
module.exports = code;